export default "__VITE_ASSET__BVArAp7U__"